<template>
    <div>
        <v-card elevation="0" v-if="displayUrgent == 'yes'">
            <v-alert prominent :type="mclassUrgent"> 
                <h3 class="text-h6">{{ titleUrgent }}</h3>
                <div>{{ textUrgent }}</div>
            </v-alert>
            <i style='float: right;margin-top: 0;'>Announcement last updated: {{ lastupdatedtimeUrgent }}</i>
            <br />
        </v-card>
        <v-card elevation="0" v-if="display == 'yes'">
            <v-alert border="left" :type="mclass" outlined> 
                <h3 class="text-h6">{{ title }}</h3>
                <div>{{ text }}</div>
            </v-alert>
            <i style='float: right;margin-top: 0;'>Announcement last updated: {{ lastupdatedtime }}</i>
            <br />
        </v-card>
        <br />
    </div>
</template>
<script>
export default {
    data(){
        return {
            host: location.hostname.toString(),
            mclass: "",
            title: "",
            text: "",
            lastupdatedtime: "",
            display: "no",
            mclassUrgent: "",
            titleUrgent: "",
            textUrgent: "",
            lastupdatedtimeUrgent: "",
            displayUrgent: "no"
        }
    },
    methods: {
        getAnnouncement(){
            const that = this;

            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=getAnnouncement';

            //API calling
            fetch(api)
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/^OK/i)){
                        that.display = "yes";
                        that.mclass = "error";
                        that.text = "Failed to retrieve announcement. Please contact King's HR to confirm.";
                    }else {
                        let urgent = resultData.data.urgent;
                        let general = resultData.data.general;

                        that.displayUrgent = urgent["display"];
                        that.display = general["display"];
                        
                        if(general["display"] == "yes"){
                            var date = new Date();
                            if(general.hasOwnProperty("updatedTimestamp")){
                                date = new Date(parseFloat(general["updatedTimestamp"]));
                            }else {
                                date = new Date(parseFloat(general["createdTimestamp"]));
                            }
                             that.lastupdatedtime = date.toDateString()+", "+String(date.getHours()).padStart(2, '0')+":"+String(date.getMinutes()).padStart(2, '0')+":"+String(date.getSeconds()).padStart(2, '0');
                            that.mclass = general["class"];
                            that.title = general["title"];
                            that.text = general["text"];
                        }

                        if(urgent["display"] == "yes"){
                            var dateUrgent = new Date();
                            if(general.hasOwnProperty("updatedTimestamp")){
                                dateUrgent = new Date(parseFloat(urgent["updatedTimestamp"]));
                            }else {
                                dateUrgent = new Date(parseFloat(urgent["createdTimestamp"]));
                            }
                            that.lastupdatedtimeUrgent = dateUrgent.toDateString()+", "+String(dateUrgent.getHours()).padStart(2, '0')+":"+String(dateUrgent.getMinutes()).padStart(2, '0')+":"+String(dateUrgent.getSeconds()).padStart(2, '0');
                            that.mclassUrgent = urgent["class"];
                            that.titleUrgent = urgent["title"];
                            that.textUrgent = urgent["text"];
                        }
                    }
                })
                .catch(function(err){
                    that.mclass = "error";
                    that.text = "Error: "+err;
                })
            //End of API calling
        },
    },
    created(){
        const that = this;
        that.getAnnouncement();
    }
}
</script>